import PropTypes from "prop-types";

import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import MDTypography from "components/MDTypography";
import MediaPicker from "components/content/MediaPicker";

/**
 * Batch 3.3 — <WhitepaperFields>. The Whitepaper type block. The download file
 * is required and uploaded as a PRIVATE asset (gated). The gating form itself
 * is handled by ContentBaseFields, since whitepapers are always gated.
 */
function WhitepaperFields({ value, onChange, websiteId }) {
  const set = (key) => (event) => onChange({ [key]: event.target.value });

  return (
    <Stack spacing={3}>
      <MDBox display="flex" alignItems="center" gap={1}>
        <MDTypography variant="button" fontWeight="bold" textTransform="uppercase" color="text">
          Whitepaper details
        </MDTypography>
        <MDBadge badgeContent="Gated" color="info" variant="gradient" size="sm" container />
      </MDBox>

      <MediaPicker
        label="Download file (required)"
        value={value.download_file}
        onChange={(id) => onChange({ download_file: id })}
        websiteId={websiteId}
        visibility="private"
        accept=".pdf,.doc,.docx,application/pdf"
      />

      <TextField label="Industry" value={value.industry} onChange={set("industry")} fullWidth />
      <TextField
        label="Target audience"
        value={value.target_audience}
        onChange={set("target_audience")}
        fullWidth
      />
      <TextField
        label="Author credentials"
        value={value.author_credentials}
        onChange={set("author_credentials")}
        fullWidth
        multiline
        minRows={2}
      />
    </Stack>
  );
}

WhitepaperFields.defaultProps = {
  websiteId: undefined,
  context: {},
};

WhitepaperFields.propTypes = {
  value: PropTypes.shape({
    download_file: PropTypes.string,
    industry: PropTypes.string,
    target_audience: PropTypes.string,
    author_credentials: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  websiteId: PropTypes.string,
  context: PropTypes.object,
};

export default WhitepaperFields;
